<template>
    <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="../assets/clothing-image.jpg" class="d-block w-100" alt="...">
      <div class="carousel-caption d-md-block">
        <h2>Apparel</h2>
        <p>Stay up to date with our latest lines.</p>
        <p class="bordered-button text-center" @click="this.$router.push('/apparel')">Explore Clothes</p>
      </div>
    </div>
    <div class="carousel-item">
      <img src="../assets/electronics-image.jpg" class="d-block w-100" alt="...">
      <div class="carousel-caption d-md-block text-center">
        <h2>Electronics</h2>
        <p class="">Check out our selection of phones, tablets, and more.</p>
        <p class="bordered-button text-center" @click="this.$router.push('/electronics')">Explore Tech</p>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
</template>

<script>
export default{
    name:"CarouselView"
}
</script>

<style scoped>
.carousel-item {
  height: 600px; /* set to your desired height */
}

.carousel-item img {
  object-fit:fill;
  height: 100%;
}
.bordered-button{
    border: white solid 3px;
    padding: 20px;
    width: 200px;
    margin: auto !important;
}
</style>